/**
 * file : BoardDetail.jsx
 * 설명 : 게시판 상세 화면
 */

import { Link } from 'react-router-dom';

export default function BoardDetail() {
  return (
    <div className="main" style={{ minHeight: '726px'}}>
        <div className="container text-center" style={{marginBottom: '2rem'}}>
            <h1 className="common-title--h1 text-gray-2">게시판</h1>
        </div>
        <div className="container">
            <table className="table-view-01 txt-mt">
                <caption></caption>
                <colgroup>
                    <col width="90px" />
                    <col width="100%" />
                </colgroup>
                <tbody>
                    <tr>
                        <td colSpan="2" className="clearfix tit_box">
                            <p className="tit">Custom Solutions</p>
                            <p className="tbl_detail_span detail_span">
                                <span>HS 솔루션</span>
                                <span className="line">2023-07-07</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2">
                            <div className="board-box multiline-text">			  
                                ㅁㅁ
                            </div>
                        </td>
                    </tr>
                </tbody>
                </table>
                <div className='text_right'>
                    <Link to="/Board" className="basebtn">목록</Link>
                </div>
        </div>
    </div>
  )
}